module.exports = __webpack_public_path__ + "img/contract.e79144ae.svg";